import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "App-Admin-Table",
      size: "medium",
      stripe: "",
      data: _ctx.opportunities,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "#ID",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              content: scope.row._id
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "el-icon-office-building" }, null, -1)
              ]))]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "business",
          label: "Startup",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.business.name)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "outcome",
          label: "Outcome"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.outcome)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "WOW",
          label: "WOW",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.wow)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "skill",
          label: "Skill",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.skill[0])) + " / " + _toDisplayString(_ctx.$filters.capitalize(scope.row.skill[1])), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "talents",
          label: "Talents",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.talents), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Is Active",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_switch, {
              "model-value": !scope.row.isArchived,
              size: "mini"
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Actions",
          width: "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "el-icon-more",
              "is-borderless": "",
              circle: "",
              plain: "",
              size: "small"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}